import { current } from "@reduxjs/toolkit";
import { BaseState } from "src/models/store";

export const asyncIsPending = (state: BaseState) => {
  console.log('state:', current(state));  
  state.status = 'pending';
}

export const asyncIsRejected = (state: BaseState, action: any) => {
  console.log('REJECTED:: ', action);
  state.status = 'rejected';
  state.message = action.payload?.message;
}

export const asyncIsFulfilled = (state: BaseState, action: any) => {
  console.log('FULFILLED:: ', action.payload.message);
  state.status = 'fulfilled';
  state.stage = action.payload?.stage;
  state.message = action.payload?.message;
}